import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Input, Component, NgModule } from '@angular/core';
import * as i2 from '@yourcause/common/icons';
import { IconsModule } from '@yourcause/common/icons';

class BadgeComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: BadgeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: BadgeComponent, isStandalone: false, selector: "yc-badge", inputs: { innerText: "innerText", innerIcon: "innerIcon" }, ngImport: i0, template: "<div>\n  <yc-fa [icon]=\"innerIcon\"></yc-fa>\n  <span *ngIf=\"innerIcon\">&nbsp;</span>\n  {{ innerText }}\n</div>\n", styles: [":host{display:flex;margin-bottom:-30px;z-index:1;position:relative;top:-10px}:host div{z-index:1;width:100%;margin-right:30px;margin-left:30px;height:30px;background-color:#1e8d64;color:#fff;display:inline-flex;justify-content:center;align-items:center;box-shadow:2px 2px 2px #a5acb2bf}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.FontAwesomeComponent, selector: "yc-fa", inputs: ["color", "icon", "tooltipText", "popoverTemplate", "light", "regular", "solid"], outputs: ["onClick"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: BadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-badge', standalone: false, template: "<div>\n  <yc-fa [icon]=\"innerIcon\"></yc-fa>\n  <span *ngIf=\"innerIcon\">&nbsp;</span>\n  {{ innerText }}\n</div>\n", styles: [":host{display:flex;margin-bottom:-30px;z-index:1;position:relative;top:-10px}:host div{z-index:1;width:100%;margin-right:30px;margin-left:30px;height:30px;background-color:#1e8d64;color:#fff;display:inline-flex;justify-content:center;align-items:center;box-shadow:2px 2px 2px #a5acb2bf}\n"] }]
        }], propDecorators: { innerText: [{
                type: Input
            }], innerIcon: [{
                type: Input
            }] } });

class BadgeModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: BadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: BadgeModule, declarations: [BadgeComponent], imports: [CommonModule,
            IconsModule], exports: [BadgeComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: BadgeModule, imports: [CommonModule,
            IconsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: BadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        IconsModule
                    ],
                    declarations: [
                        BadgeComponent
                    ],
                    exports: [
                        BadgeComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BadgeComponent, BadgeModule };
